import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import env from 'misc/env';
import { sessionStorage } from './storage';
var crypto = window.crypto;

/**
 * A transaction manager to manange the state of our PKCE flow.
 */
export var AuthTransactionManager = /*#__PURE__*/function () {
  function AuthTransactionManager() {
    _classCallCheck(this, AuthTransactionManager);
    this.storageKey = "worklayer-auth.".concat(env.AUTH0_CLIENT_ID);
  }

  /**
   * Creates a new authentication transaction and generatees a code verifier.
   *
   * @returns
   */
  return _createClass(AuthTransactionManager, [{
    key: "create",
    value: (function () {
      var _create = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var transaction;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              transaction = {
                verifier: generateRandomBase64String(15),
                state: generateRandomBase64String(15)
              };
              sessionStorage.setItem(this.storageKey, JSON.stringify(transaction));
              _context.next = 4;
              return generateCodeChallenge(transaction.verifier);
            case 4:
              _context.t0 = _context.sent;
              _context.t1 = transaction.state;
              return _context.abrupt("return", {
                code_challenge: _context.t0,
                code_challenge_method: 'S256',
                state: _context.t1
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function create() {
        return _create.apply(this, arguments);
      }
      return create;
    }()
    /**
     * Gets the latest authentication transaction.
     *
     * @returns
     */
    )
  }, {
    key: "get",
    value: function get() {
      var transaction = sessionStorage.getItem(this.storageKey);
      if (!transaction) {
        return;
      }
      return JSON.parse(transaction);
    }

    /**
     * Removes any transaction.
     */
  }, {
    key: "clear",
    value: function clear() {
      sessionStorage.removeItem(this.storageKey);
    }
  }]);
}();
function cleanBase64(str) {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function generateRandomBase64String(length) {
  return cleanBase64(btoa(crypto.getRandomValues(new Uint8Array(length))));
}
function generateCodeChallenge(_x) {
  return _generateCodeChallenge.apply(this, arguments);
}
function _generateCodeChallenge() {
  _generateCodeChallenge = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(verifier) {
    var data, hashBuffer, binary;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          data = new TextEncoder().encode(verifier);
          _context2.next = 3;
          return crypto.subtle.digest('SHA-256', data);
        case 3:
          hashBuffer = _context2.sent;
          binary = String.fromCharCode.apply(null, new Uint8Array(hashBuffer));
          return _context2.abrupt("return", cleanBase64(btoa(binary)));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _generateCodeChallenge.apply(this, arguments);
}
//# sourceMappingURL=AuthTransactionManager.js.map
